import { useMutation, useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { cashAppLocal } from '@squareup/dashboard-query/queries/cash-app-local';
import type { BrandLocationConfiguration } from '@squareup/shared-types-protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.js';

export function useCashAppDefaultBrand() {
  return useQuery(cashAppLocal.defaultBrand());
}

// Maps brand location configuration by their ID
export function useLocationOrderingConfigByIdMap() {
  const { data: defaultBrandData } = useCashAppDefaultBrand();
  return useMemo(() => {
    if (!defaultBrandData) {
      return {};
    }
    return defaultBrandData.locationConfigurations.reduce((acc, locationConfig) => {
      if (!locationConfig.unitToken) {
        return acc;
      }
      acc[locationConfig.unitToken] = locationConfig;
      return acc;
    }, {} as Record<string, BrandLocationConfiguration>);
  }, [defaultBrandData]);
}

export function useUpdateOrderingConfiguration() {
  return useMutation(cashAppLocal.updateOrderingConfiguration());
}
